import React from "react";
import Slider from "react-slick";
import Rcard from "./Testimonialprops";
import Boy from "./../../Assest/boy.png";
import Girl from "./../../Assest/girl.png";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import classes from "./Testimonials.module.css";
/*
import t1 from "./../../Assests/golde.png";
import t2 from "./../../Assests/siresj.png";
import t3 from "./../../Assests/dipika.png";
import t4 from "./../../Assests/p.png";

*/
const Testimonial = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 8000,
        autoplay: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 768,
              settings: {
                speed: 8000,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false  
              }
            }
        ]
    };

    return (
<div> 

<div className={classes.rsl}>
      
    <h2 className={classes.ih3h}>TESTIMONIALS</h2>
<div className={classes.rsl2}>      
                <Slider {...settings}>

<div> {/*imgg={t1} */}
<Rcard imgg={Boy}  name='Aryan Roy ' clg='KGMC College' review='Grateful to Rushikesh Sir for his constant guidance and support—proud to be studying at King George’s Medical University, Lucknow.' ></Rcard>
</div>
<div>
<Rcard imgg={Boy} name='Shaurya Yashwante'  clg='Grant Govt College' review='Because of Rushikesh Sir’s clear and reliable counselling, I successfully secured admission and am now studying at G. T. Cama' ></Rcard>
</div>
<div>
<Rcard imgg={Girl} name='Saniya Sonawane' clg='GT Camma Govt Medical College' review='Amazing services… kudos to you …👏👏👏 creativity on the top - Mukesh' ></Rcard>
</div>
<div>
<Rcard imgg={Girl} name='Ruchika Chaudhary' clg='BKL Walawalkar Medical College ' review='Thanks to Rushikesh Sir for his clear and honest guidance—because of his support, I am now studying at B. K. L. Walawalkar Medical College.' ></Rcard>
</div>
<div>
<Rcard imgg={Boy} name='Ajinkya Kawade' clg='College OF Engineering' review='Thanks to Rushikesh Sir for clear and timely guidance, I secured admission at college of Engineering (COEP)' ></Rcard>
</div>






                </Slider>
                </div>
       </div>     
   </div>    
    );
}

export default Testimonial;
